import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=75ac4ba7&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=75ac4ba7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac4ba7",
  null
  
)

export default component.exports